import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { CustomerConnection } from "../../../api/ChannelCustomer";
import { CHANNEL_TYPE_LABELS } from "../../chats/channelTypes";

interface Props {
    open: boolean;
    connection?: CustomerConnection | null;
    onClose: () => void;
}

export default function CustomerDetailsModal({
    open,
    connection,
    onClose,
}: Props) {
    const { t } = useTranslation();

    const formatDate = (raw?: string) => {
        if (!raw) return "";
        const d = new Date(raw);
        return Number.isNaN(d.getTime()) ? "" : d.toLocaleString();
    };

    const typeCode = connection?.channel_connection?.channel_type_code || connection?.source || "";

    // Chỉ hiển thị những trường thực sự có trong quan hệ connections
    const data = [
        { label: t('cd.channel_name'), value: connection?.channel_customer?.display_name || "" },
        { label: t('cd.page_name'), value: connection?.channel_connection?.display_name || "" },
        { label: t('cd.source'), value: typeCode ? (CHANNEL_TYPE_LABELS[typeCode] || typeCode) : "" },
        { label: t('cd.channel_customer_id'), value: connection?.channel_customers_id ? String(connection.channel_customers_id) : "" },
        { label: t('cd.channel_linked_at'), value: formatDate(connection?.created_at) },
    ];

    return (
        <Modal
            title={t('cd.detail_title')}
            open={open}
            onCancel={onClose}
            footer={null}
            width={650}
            centered
            className="dark:[&_.ant-modal-content]:bg-[#141414]
                 dark:[&_.ant-modal-header]:bg-[#141414]
                 dark:[&_.ant-modal-title]:text-gray-200"
        >
            <div className="rounded-lg border border-gray-200 dark:border-[#303030] overflow-hidden">
                {data.map((item, index) => (
                    <div
                        key={index}
                        className="grid grid-cols-2 border-b last:border-none
                       border-gray-200 dark:border-[#303030]"
                    >
                        <div className="bg-gray-50 dark:bg-[#1f1f1f]
                            px-4 py-3 text-gray-600 dark:text-gray-400">
                            {item.label}
                        </div>
                        <div className="px-4 py-3 text-gray-800 text-000000e0">
                            {item.value || "—"}
                        </div>
                    </div>
                ))}
            </div>
        </Modal>
    );
}
